/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'
import { draw } from '../model/inputs.model'

export const useDrawCanvas = (params: draw = null) => {
  const [ctx, setCtx] = useState(null)
  const [loaded, setLoaded] = useState(false)

  const [labels, setLabels] = useState<any[]>([])
  const [images, setImages] = useState<any[]>([])

  const width = 1080
  const height = 1080

  useEffect(() => {
    const canvas: any = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const canvasContext = canvas.getContext('2d')
    setCtx(canvasContext)
  }, [])

  useEffect(() => {
    if (ctx !== null) {
      ctx.clearRect(0, 0, width, height)
    }
  }, [ctx])

  //外枠
  useEffect(() => {
    if (ctx !== null) {
      ctx.beginPath()
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, width, height)
      ctx.beginPath()
      ctx.fillStyle = 'rgba(0, 0, 0, 0.8)'
      ctx.lineWidth = 1
      ctx.strokeRect(0, 0, width, height)
      setLoaded(true)
    }
  }, [ctx])

  //タイトル
  useEffect(() => {
    if (ctx !== null) {
      ctx.clearRect(1, 454, 1078, 81)
      ctx.fillStyle = 'white'
      ctx.fillRect(1, 454, 1078, 81)

      ctx.fillStyle = 'rgba(0, 0, 0, 0.8)'
      const title = params ? params.title : ''
      const fontSize = 64
      ctx.font = 'bold ' + fontSize + 'px Zen Kaku Gothic New, sans-serif'
      let textWidth = ctx.measureText(title).width
      ctx.globalCompositeOperation = 'source-over'
      ctx.fillText(title, (1080 - textWidth) / 2, fontSize + 454)

      setLoaded(true)
    }
  }, [loaded, params, ctx])

  //サブタイトル
  useEffect(() => {
    if (loaded) {
      ctx.clearRect(1, 584, 1078, 84)
      ctx.fillStyle = 'white'
      ctx.fillRect(1, 584, 1078, 84)

      ctx.fillStyle = 'rgba(0, 0, 0, 0.8)'
      const subtitle = params ? params.subtitle : ''
      const subfontSize = 44
      ctx.font = subfontSize + 'px Zen Kaku Gothic New, sans-serif'
      let subtextWidth = ctx.measureText(subtitle).width
      ctx.globalCompositeOperation = 'source-over'
      ctx.fillText(subtitle, (1080 - subtextWidth) / 2, subfontSize + 590)

      setLoaded(true)
    }
  }, [loaded, params, ctx])

  //センターライン（上）
  useEffect(() => {
    if (loaded) {
      ctx.moveTo(23, 556)
      ctx.lineTo(1057, 556)
      ctx.lineWidth = 5
      ctx.stroke()
      setLoaded(true)
    }
  }, [loaded, ctx])

  //センターライン（下）
  useEffect(() => {
    if (loaded) {
      ctx.moveTo(23, 567)
      ctx.lineTo(1057, 567)
      ctx.lineWidth = 2
      ctx.stroke()
      setLoaded(true)
    }
  }, [loaded, ctx])

  //ランキングラベルセット
  useEffect(() => {
    setLabels([])
    if (loaded) {
      for (let i = 0; i < 2; i++) {
        for (let j = 0; j < 3; j++) {
          let idx = i * 2 + i + (j + 1)

          const label = new Image()
          label.src = `${process.env.PUBLIC_URL}/img/img_rank_${idx}.png`
          label.onload = () => {
            const _label = {
              image: label,
              sx: 0,
              sy: 0,
              sw: 340,
              sh: 330,
              dx: 13 + 351 * j,
              dy: 58 + 659 * i,
              dw: 151,
              dh: 158,
            }
            setLabels((prev) => [...prev, _label])
          }
        }
      }
      setLoaded(true)
    }
  }, [ctx, loaded])

  //イメージセット
  useEffect(() => {
    if (loaded) {
      for (let i = 0; i < 2; i++) {
        for (let j = 0; j < 3; j++) {
          let idx = i * 2 + i + j
          if (params?.data[idx].file) {
            const img = new Image()
            img.src = URL.createObjectURL(params.data[idx].file)
            img.onload = () => {
              const size = {
                width: img.naturalWidth,
                height: img.naturalHeight,
              }
              const shift_x = (size['width'] - 330) / 2
              const shift_y = (size['height'] - 330) / 2

              const _photos = {
                no: idx,
                image: img,
                sx: shift_x,
                sy: shift_y,
                sw: 340,
                sh: 330,
                dx: 23 + 351 * j,
                dy: 45 + 660 * i,
                dw: 330,
                dh: 330,
              }
              setImages((prev) => [...prev, _photos])
            }
          }
        }
      }
      setLoaded(true)
    }
  }, [params, ctx, loaded])

  //写真、ラベル描画
  useEffect(() => {
    if (loaded) {
      //写真
      removeDuplicates(images).map((p) => {
        return ctx.drawImage(p.image, p.sx, p.sy, p.sw, p.sh, p.dx, p.dy, p.dw, p.dh)
      })

      //ラベル
      removeDuplicates(labels).map((p) => {
        return ctx.drawImage(p.image, p.sx, p.sy, p.sw, p.sh, p.dx, p.dy, p.dw, p.dh)
      })
    }
  }, [ctx, images, labels, loaded])

  return { ctx }
}

// 重複削除用
const removeDuplicates = (object: any) => {
  var result = [],
    comparisons = [],
    comparison

  for (var key in object) {
    comparison = JSON.stringify(object[key])

    if (comparisons.indexOf(comparison) === -1) result.push(object[key])

    comparisons.push(comparison)
  }

  return result
}
